import React from 'react';
import { UpsellIconContainer } from './UpsellIcon.styles';

const UpsellIcon = () => {
  return <UpsellIconContainer>$ UPSELL</UpsellIconContainer>;
};

export default UpsellIcon;
